import EmbeddedJSPopup from './EmbeddedJSPopup';

export default EmbeddedJSPopup;
